/**
 * 再資源化
 * 再資源化処分場処理方法
 */
import Vue from "vue";
import * as httpConst from "../../../../constants/httpConst";
import * as types from "../../../mutation-types/driver-types";


const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/recycle_disposer_disposal_methods`;

const getDefaultState = () => {
  return {};
};

const master_recycle_disposer_disposal_method = {
  namespaced: true,
  state: getDefaultState(),
  getters: {},
  actions: {

    /**
     * 再資源化処分場処理方法一覧の取得
     * @param param0
     * @param param0.commit
     * @param param1
     * @param param1.condition
     * @param param1.page
     * @return {Promise<Object>}
     */
    index ({ commit }, { condition, page, limit, format }) {
      let api_path

      if (format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = API_PATH
      }
      const params = {
        ...condition,
        page: page,
        limit: limit,
      }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then((data) => {
          if (format !== 'csv') {
            let content = data.content
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },

    /**
     * 再資源化処分場処理方法 新規
     * @return {Promise<Object>}
     */
    new () {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/new`).then(data => {
          let content = data.content
          resolve(content)
        })
      });
    },

    /**
     * 再資源化処分場処理方法 詳細・編集
     * @param param0
     * @param param0.commit
     * @param param1
     * @param param1.id
     * @return {Promise<Object>}
     */
    edit ({ commit }, { id }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/${id}/edit`).then(data => {
          let content = data.content
          resolve(content)
        })
      });
    },

    /**
     * 再資源化処分場処理方法 登録
     * @param param0
     * @param param0.commit
     * @param param1
     * @param param1.params
     * @return {Promise<unknown>}
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },

    /**
     * 再資源化処分場処理方法 更新
     * @param param0
     * @param param0.commit
     * @param param1
     * @param param1.id
     * @param param1.params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(`${API_PATH}/${id}`, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },

    /**
     * 再資源化処分場処理方法 削除
     * @param param0
     * @param param0.commit
     * @param param1
     * @param param1.id
     * @return {Promise<unknown>}
     */
    destroy ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        Vue.$http.delete(`${API_PATH}/${id}`).then(data => {
          let content = data.content;
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(content)
        })
      })
    },
  },
  mutations: {},
};

export default master_recycle_disposer_disposal_method;
